import { FormBuilder,FormGroup } from '@angular/forms';
import { DecimalPipe } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FileUploadService } from '../../services/file-upload.service';
import { FilesUploadedTableI } from '../file-upload/model/filesUploadedTable';
import { HttpEventType } from '@angular/common/http';


@Component({
	selector: 'app-static-table',
	templateUrl: './static-table.component.html',
	styleUrls: ['./static-table.component.scss']
})
export class StaticTableComponent {

	@Input() public tableData!: FilesUploadedTableI[];
	@Input() public dataTypeList: any;
    public uploadProgress: { [key: number]: number } = {};

	@Output() public emitDeleteRow: EventEmitter<any> = new EventEmitter<any>();
	@Output() public emitSelectedDropdownList: EventEmitter<any> = new EventEmitter<any>();

	public selectedDropdownList: any = [];
	public documentUploadTableForm!: FormGroup;
  public progressColor!:string;
	constructor(private formBuilder: FormBuilder, public _decimalPipe: DecimalPipe, public fileUploadService: FileUploadService, private activatedRoute: ActivatedRoute,
		) { }

	// eslint-disable-next-line @angular-eslint/use-lifecycle-interface
	public ngOnInit() {
		this.documentUploadTableForm = this.createForm();
	}


	public deleteRow(row: any) {
		if (this.selectedDropdownList[row.id]) {
			this.selectedDropdownList.splice(Number(row.id), 1);
		}

		this.fileUploadService.selectedDropdownList(this.selectedDropdownList);
		this.emitDeleteRow.emit(row.id);
	}

	public selectDropDownOption(event: any, index: any) {
		this.selectedDropdownList[index] = (event.target.value);
		this.fileUploadService.selectedDropdownList(this.selectedDropdownList);
	}

	public createForm(): FormGroup {
		return this.formBuilder.group({
			documentType: ["", []]
		})
	}

  public uploadFile(event: any, index: number) {
    const files = event.target.files;
    if (files && files.length > 0) {
      const file = files[0];
      this.uploadProgress[index] = 0;
      this.progressColor = '#f1f1f1';

      this.fileUploadService.uploadFile(file).subscribe(
        (event: any) => {
          if (event.type === HttpEventType.UploadProgress) {
            const progress = (event.loaded / event.total) * 100;
            this.uploadProgress[index] = progress;

            if (progress === 100) {
              this.progressColor = '#008567';
            }
          } else if (event.type === HttpEventType.Response) {
          }
        },
        (error) => {
          console.error('Error uploading file', error);
          this.progressColor = '#EB0000';
          this.uploadProgress[index] = -1;
        },
      )}
  }


}
